<span *ngIf="lksvc.current_differential_lieferkunde$|async" style="color: orange; font-size: 12px">
  <div style="display: inline-block; vertical-align: middle; cursor: help; " [matTooltip]="'Lieferung für ' + (name|async)">
    {{((name|async).length>20)? ((name|async) | slice:0:20)+'..':((name|async))}}
  </div>

  <button mat-icon-button (click)="reset()" matTooltip="Verlassen" style="vertical-align: middle">
    <svg-icon>abbrechen</svg-icon>
  </button>
</span>
